/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Apply_ConfirmInputs */

const en_template_apply_confirm = /** @type {(inputs: Template_Apply_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply template`)
};

const de_template_apply_confirm = /** @type {(inputs: Template_Apply_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage anwenden`)
};

/**
* | output |
* | --- |
* | "Apply template" |
*
* @param {Template_Apply_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const template_apply_confirm = /** @type {((inputs?: Template_Apply_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Apply_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_apply_confirm(inputs)
	return de_template_apply_confirm(inputs)
});